import { useEffect } from 'react';
import './complex2.scss';
import PageContent from '../content';
import styled from 'styled-components';
import { ResponseHomeNewsDetail } from 'common-modules/general/API/news/types';
import { observer, useLocalObservable } from 'mobx-react';
import { toJS } from 'mobx';
import ComplexNewsCommonModel from 'common-modules/general/Common/Logic/News/NewsCommon';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { cdBizLnd } from 'data/configs';

const NewsDetail = observer(() => {
  const params = useLocation();
  const id = params.search.replace('?id=', '');
  const { model: mainModel } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));
  const history = useHistory();

  const detailData = toJS(mainModel.detailData.data);

  useEffect(() => {
    if (typeof id === 'string') {
      const changeIdType = Number(id);
      mainModel.getNewsDetailData(cdBizLnd, changeIdType);
    } else {
      mainModel.getNewsDetailData(cdBizLnd, id);
    }
  }, []);

  if (mainModel.detailData.loadStatus === 'READY' && detailData) {
    return (
      <div className="complex2-container">
        <div className="complex-content">
          <PageContent data={detailData} />
          <div className="btn-wrap" onClick={() => history.push(RoutesString.SalesNews)}>
            <Button>목록</Button>
          </div>
        </div>
      </div>
    );
  } else if (mainModel.detailData.loadStatus === 'PENDING') {
    return <div style={{ height: '1000px' }}></div>;
  } else {
    return <Redirect to={RoutesString.SalesNews} />;
  }
});

export default NewsDetail;

const Button = styled.button`
  font-size: 1.125rem;
  word-break: keep-all;
  word-wrap: break-word;
  color: #fff;
`;
